/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import globalEvents from "web/script/utils/global-events";

export default baustein.register("saved-search-delete-confirmation", {
    defaultOptions: {
        deleteSavedSearchId: null
    },

    setupEvents(add) {
        add("click", ".confirmation-prompt__button--yes", this.delete);
        add("click", ".confirmation-prompt__button--no", this.closeOverlay);
    },

    closeOverlay() {
        analytics.event("clicked", "no delete saved search");
        globalEvents.trigger("confirmation-prompt-closed");
    },

    delete() {
        analytics.event("clicked", "yes delete saved search").then(() => {
            globals.window.location = `/my-searches/delete/${this.options.deleteSavedSearchId}/`;
        });
    }
});

